import DataActions, { DataAction } from './actions'
import { DataState } from './types'

const DataReducer = (DataState: DataState | never, action: DataAction): DataState | never => {
    switch (action.type) {
        case DataActions.SET_DEALERS: {
            return {
                ...DataState,
                dealers: action.payload.dealers,
            }
        }
        case DataActions.SET_BUSINESS_UNITS: {
            return {
                ...DataState,
                businessUnits: action.payload.businessUnits,
            }
        }

        default: {
            throw Error('Unknown action: ' + action.type)
        }
    }
}

export default DataReducer
